import { useState, useEffect, useContext, useRef } from "react";
import { useLoaderData, useActionData, redirect, Form, useSearchParams, Link, useSubmit, useNavigate  } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import MenuContext from '../store/MenuContext';
import LabIDContext from '../store/LabIDContext';
import {getTableForm, getLabConfig, actAccount, getSystemMsg } from '../utils/api';
import {addRequiredStateTest} from '../utils/auth';

import FormHelper from '../components/UI/FormHelper';

import HeaderClasses from '../components/AppHeader/AppHeader.module.css';
import RegisterClasses from '../components/Register/Register.module.css';

const RegHeader = () => {
	const menuTheme = useContext(MenuContext);

  return (
	 <div>		  
		 <h2 className={RegisterClasses.testTitle}>
		  Activate Account
        </h2>
      <p >
		  Please check your email for your activation code.  Cut and paste the activation code below.  
		  This will log you in and your cart will remain in tact. 
		  <br/><br/>
		  If you choose to click the link in the email, you will be taken to a new window and your cart will be empty.
		  You can complete your activation, and return to this window and log in.
	      <br/><br/>
	      Fill out all required (*) fields prior to clicking save.
      </p>
    </div>
  );
};

const ActivateAccount = () => {
	const [searchParams] = useSearchParams();
	const actCode=searchParams.get("actCode");
	const submit = useSubmit();
	const [tableForm, PatientPortalCustomerServiceEmail]=useLoaderData();
	const actionData=useActionData();
	const cartState = useSelector(state => state.cart);
	const [formError,setFormError] = useState({});
   	const tfHandler = (tferror) => {
		let newtfError={...tferror}
		setFormError(newtfError);
	};
	const dispatch = useDispatch();
	const navigate = useNavigate();
    const ranRef = useRef(false);
	const [msg,setMsg] = useState('');
	  useEffect(() => {
		async function fetchMessage() {
		  try {
			const data = await getSystemMsg("Restricted States");
			setMsg(data);
		  } catch (err) {
			console.error("Failed to fetch message:", err);
			setMsg("Thank you for trusting us!"); // fallback message
		  }
		}
		fetchMessage();
	  }, []);
	useEffect(() => {
		const qty = Number(actionData?.cartQty) || 0;
		if (qty >= 1 && !ranRef.current) {
		  ranRef.current = true;
		  (async () => {
			const addedTests = await addRequiredStateTest(dispatch);
			if(addedTests !== "CANNOT ORDER") {
				if (addedTests === "WARNING") {
					alert(JSON.stringify(msg, null, 2));
				}
				navigate("../cart?review=1", { replace: true });
			}else{
				navigate("../noServiceSysMsg", { replace: true});
			}	
		  })();
		}
	  }, [actionData, dispatch, navigate]);
	const handleSubmit = async (event) => {
		event.preventDefault();
		console.log(formError);
		if(Object.keys(formError).length ===0) {
			await submit(event.currentTarget, { method: 'post' });
			//handle errors.....
		}
	};
	const opencontactus = () => {
		window.location.href = `mailto:${PatientPortalCustomerServiceEmail}?body=`;
	};
	const menuTheme = useContext(MenuContext);

  return (
		  <div className={RegisterClasses.testInfo}>
		  <div className={RegisterClasses.testInfoContent}>
			  
		  <Form method='post'>
		  	<RegHeader />
			  <FormHelper TF={tableForm} urlvalue= {actCode} onTF={tfHandler}/ >
			  <input type="hidden" name="cartQTY" defaultValue={cartState.totalQuantity} />
			  {actionData?.message && <span>{actionData.message}</span>}
			  {actionData?.errors && <span>{actionData.errors}</span>}
			  
			  <div className={RegisterClasses.buttonArea}> 
			  	<button className={RegisterClasses.buttonDarkBlue} onClick={handleSubmit}>	Save  </button>
			  </div>
			  <Link className={HeaderClasses.navAreaText} to='../ForgotUsername?resend=1'>Resend Activation Email</Link>	
		 </Form>
	    </div>
	    <div className={RegisterClasses.buttonArea}>  
			<div className={HeaderClasses.navArea}>
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				<div>
				Need Help? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				<button type="button" className={RegisterClasses.buttonDarkBlue} onClick={opencontactus} >
					{'Contact Us'}
				</button>
				</div>
			</div>
		</div>
	   
		
	</div>
  );
};
export default ActivateAccount;

export async function tfLoader() {
    const response = await getTableForm('DTC:Patient','ActivateAccount');
	const resData = await response;
		return resData;
}
export async function supportEmail() {
    const response = await getLabConfig('PATIENTPORTALCUSTOMERSUPPORTEMAIL');
	const resData = await response;
		return resData;
}

export  async function actLoader() {
	return Promise.all([tfLoader(),supportEmail()]);
}
	
export async function activateAccountAction({ request, params }) {
  const data = await request.formData();
  const messages={};
  const actData = {
	username: data.get('UserName'),
	password: data.get('new-password'),
	activationCode: data.get("ActivationCode").trim()
  };
  console.log("action");
  const response = await actAccount(actData);
  
  if(response.ok && response.status === 204) {
		  messages.errors = "Please choose a different username, that one is taken."
  }else if (response.token) {
	  	messages.message="You are now registered.  Logging you in...."
		const token = response.token;
		const labtestid = response.labtestid;
		messages.message="Welcome!"
		sessionStorage.setItem('token', token);	
		sessionStorage.setItem('Labtestid',labtestid);
		sessionStorage.setItem('Adult','Yes');
		const expiration = new Date();
		expiration.setHours(expiration.getHours() + 1);
		sessionStorage.setItem('expiration', expiration.toISOString());
		if(data.get("cartQTY") >=1) {
			messages.cartQty=data.get("cartQTY");
			return(messages);
			//await addRequiredStateTest(dispatch);
			//return redirect('../cart?review=1');
		}
		if(data.get("cartQTY") <1) return redirect('../');
  };
 if(!response.ok && response.status === 401){
	  messages.errors = "Invalid activation code."
  }
 if(!response.ok && response.status === 400){
	  messages.errors = "Invalid data."
  }
return messages;  
}
